module.exports = "/static/assets/d889a872f3b0985b28fa872764172ef1.svg";